import { FilterGroup, IFilters } from 'types';
import { FilterItem } from './FilterItem';
import { filterItemCount } from '../filterFactoryMethods';
import { AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Heading, VStack } from '@chakra-ui/react';

export interface IProps {
  filtergroup: FilterGroup;
  openFilterSetup: (filterKey: string) => void;
  filters: IFilters;
}

export const FilterGroupComponent = (props: IProps) => {
  const { filtergroup, openFilterSetup, filters } = props;
  // const expanded = filters.expanded.some(name => name === filtergroup.name);
  return (
    <AccordionItem data-selector={`filter-group-${filtergroup.name}`}>
      <Heading as="h2">
        <AccordionButton data-selector={`filter-group-toggle-${filtergroup.name}`}>
          <AccordionIcon />
          {filtergroup.name}
        </AccordionButton>
      </Heading>

      <AccordionPanel>
        <VStack spacing="0" alignItems="stretch">
          {filtergroup.filters.map((filter, index) => {
            const setup = () => openFilterSetup(filter.key);
            const itemCount = filterItemCount(filters, filter);

            return (
              <FilterItem
                key={`FilterItem-${filtergroup.name}-${filter.key}-${index}`}
                filter={filter}
                openFilter={setup}
                count={itemCount}
              />
            );
          })}
        </VStack>
      </AccordionPanel>
    </AccordionItem>
  );
};
